import Clazz from '../common/Clazz';
import Util from '../utils/util';

/**
 * 要素数据模型基类
 * @
 */
export default class Feature extends Clazz {
    /**
     * 初始化构造函数
     * @param {Object}  data    - 接收渲染数据模型格式数据
     * @param {Object}  options - 可选参数
     * @returns {undefined}
     */
    constructor(geometry = null, properties = {}, options) {
        super(options);

        /**
         * 唯一标识
         * @type {string}
         */
        this.fid = Util.uuid();
        /**
         * 坐标几何对象
         * @type {object<geojson>}
         */
        this.geometry = geometry;
        /**
         * 属性信息对象
         * @type {object}
         */
        this.properties = properties;

        /**
         * 记录要素被渲染时用到的不同渲染器
         * @type {Array}
         */
        this.renders = [];
    }

    /**
     * 数据模型复制方法
     * @return {undefined}
     */
    clone() {
        const geometry = Util.clone(this.geometry);
        const properties = Util.clone(this.properties);
        return new this.constructor(geometry, properties, this.options);
    }

    /**
     * 判断两个要素是否相同
     * 基类中只判断了基本数据类是否相同，其他详细的判断有误需要在子类中具体实现
     * @return {bool} 是否相同
     */
    equal(other) {
        if (!other) {
            return false;
        }

        return this.constructor.is(other);
    }
}
